module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/main-731a874afa78306cdbb16c923c03528e.png";